import { render } from "./InvitePlayersPanel.vue?vue&type=template&id=549d2368&scoped=true"
import script from "./InvitePlayersPanel.vue?vue&type=script&lang=js"
export * from "./InvitePlayersPanel.vue?vue&type=script&lang=js"

import "./InvitePlayersPanel.vue?vue&type=style&index=0&id=549d2368&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-549d2368"]])

export default __exports__